import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceListCreationNotificationState = createStateReducer(initialState, {
  [events.createListSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "createList",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.createListFailed]: (state, { error }) => ({
    ...state,
    queue: updateNotification(
      {
        key: "createList",
        flags: pushIf({
          ...error,
          failure: !Object.values(error).includes(true),
        }),
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceListCreationNotificationState };
